<template>
      <infoSenhas class="px-2 mx-2 pt-2" :tipo="1"></infoSenhas>
</template>

<script>

import infoSenhas from '../../paciente/infoSenhas'

export default {

  components: {
    infoSenhas
  }

}
</script>
